/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { AthleteField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

const RelatedAthleteModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add related athlete"
    subtitle="Find an athlete related to this article"
    okText="ADD ATHLETE"
    onSubmit={({ athlete }) => onSubmit(athlete)}
  >
    <AthleteField
      label="Choose an athlete:"
      name="athlete"
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Athlete is required' }]}
    />
  </RelatedContentModal>
);

const Item = (athlete) => (
  <InfoItem image={athlete.image}>{athlete.fullName || `${athlete.firstName} ${athlete.lastName}`}</InfoItem>
);

RelatedAthleteModal.Item = Item;

export default RelatedAthleteModal;
